module.exports = __webpack_public_path__ + "img/fossil2Img2.d979953f.jpg";